import React from 'react';
import PropTypes from 'prop-types';
import {ReactQueryDevtools} from 'react-query/devtools';
import SecurityProvider from '@/contexts/SecurityProvider';
import {DialogsContextProvider} from '@/contexts/DialogsContext';
import {DetailsContextProvider} from '@/contexts/DetailsContext';
import {MultiDialogsContextProvider} from '@/contexts/MultiDialogsContext';
import {QueryClientProvider, QueryClient, QueryCache, MutationCache} from 'react-query';
import InternationalizationInitProvider from '@/contexts/InternationalizationInitProvider';

const queryCache = new QueryCache();
const mutationCache = new MutationCache();
const queryClient = new QueryClient({queryCache, mutationCache});

export const AppContextProvider = ({children}) => {

  return (
    <QueryClientProvider client={queryClient}>
      <SecurityProvider>
        <InternationalizationInitProvider>
          <DialogsContextProvider>
            <MultiDialogsContextProvider>
              <DetailsContextProvider>
                {children}
              </DetailsContextProvider>
            </MultiDialogsContextProvider>
          </DialogsContextProvider>
        </InternationalizationInitProvider>
        <ReactQueryDevtools position="bottom-right"/>
      </SecurityProvider>
    </QueryClientProvider>
  );
};

AppContextProvider.propTypes = {
  children: PropTypes.object,
};
